import { AnalyticsBrowser } from "@segment/analytics-next";

import { shouldTrack } from "./mixpanel";

let instance: AnalyticsBrowser | null = null;

export function getSegment(): AnalyticsBrowser | null {
  if (!shouldTrack()) return null;
  if (instance) return instance;

  const writeKey = import.meta.env.VITE_SEGMENT_WRITE_KEY;
  if (!writeKey) {
    return null;
  }

  instance = AnalyticsBrowser.load({ writeKey });
  return instance;
}

export function resetSegment(): void {
  getSegment()?.reset();
}
